module.exports = __webpack_public_path__ + "static/img/icon-contact.91dc8f66.png";